import React, { Component } from 'react';
import { Row, Col, Badge } from 'react-bootstrap';
import immutable from 'object-path-immutable';
import numeral from 'numeral';
import moment from 'moment';
import { connect } from 'react-redux';
import Button from '../../../components/CustomButton/CustomButton';
import * as K from '../redux/SalesConstants';
import ActionsBar from '../../../components/ActionsBar';
import BarCanceled from '../../../components/BarCancelled';
import swal from 'sweetalert';
class receiptSale extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openConfirm: false,
    };
  }

  handleEdit = (index) => {
    var newSale = immutable.set(this.props.Sales, ['indexToEdit'], index);
    newSale = immutable.set(
      newSale,
      ['dataToEdit', 'receipt'],
      this.props.Sales.receipts[index]
    );

    this.props.dispatch({
      type: K.SETSTATE,
      payload: newSale,
    });

    this.props.dispatch({
      type: K.OPEN_MODAL_ADD,
      payload: 'receipt',
    });
  };

  handleCancel = async (index, folio) => {
    let result = await swal(
      '¿Seguro que desea cancelar el recibo? ',
      'FOLIO: ' + folio,
      {
        buttons: ['No', 'Si'],
      }
    );

    if (result) {
      var newSale = immutable.set(this.props.Sales, ['indexToEdit'], index);

      newSale = immutable.set(newSale, ['dataToEdit', 'receipts'], {
        ...this.props.Sales.receipts[index],
        cancel: true,
      });

      this.props.dispatch({
        type: K.SETSTATE,
        payload: newSale,
      });

      this.props.dispatch({
        type: K.UPDATE_RECEIPT,
        payload: {
          data: {
            value: newSale.dataToEdit.receipts,
            index: index,
          },
        },
      });
      setTimeout(async () => {
        await this.props.saveSales();
      }, 200);
    }
  };

  handleDelete = (index) => {
    var newArray = immutable.del(this.props.Sales, ['receipts', index]);

    this.props.dispatch({
      type: K.SETSTATE,
      payload: newArray,
    });
  };

  handleAdd = () => {
    this.props.dispatch({
      type: K.OPEN_MODAL_ADD,
      payload: 'receipt',
    });
  };

  conceptComponent = (receipt, index = 0) => {
    return (
      <div key={index}>
        <Row>
          <Col md={12}>
            <div className="form-group">
              <label style={{ fontWeight: 'bold' }} htmlFor="client">
                CONCEPTO
              </label>
              <br />
              <span>{receipt.concept}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <div className="form-group">
              <label style={{ fontWeight: 'bold' }} htmlFor="client">
                MONTO
              </label>
              <br />
              <Badge style={{ backgroundColor: '#5FB404' }}>
                {numeral(receipt.amount).format('$0,0.00')}
              </Badge>
            </div>
          </Col>
          <Col md={6}>
            <div className="form-group">
              <label style={{ fontWeight: 'bold' }} htmlFor="client">
                TIPO DE PAGO
              </label>
              <br />
              <span>{receipt.payment}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <div className="form-group">
              <label style={{ fontWeight: 'bold' }} htmlFor="client">
                % COSTO DE MÉTODO DE PAGO
              </label>
              <br />
              <span>{receipt.percent}</span>
            </div>
          </Col>
          <Col md={6}>
            <div className="form-group">
              <label style={{ fontWeight: 'bold' }} htmlFor="client">
                CLAVE
              </label>
              <br />
              <span>{receipt.clave}</span>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  render() {
    let { Sales } = this.props;

    return (
      <div style={{ textAlign: 'justify' }}>
        <Row>
          <Col md={12}>
            {Sales.receipts.map((receipt, index) => {
              return (
                <div key={index} style={{ marginBottom: '30px' }}>
                  {receipt && receipt.cancel ? (
                    <BarCanceled title="RECIBO CANCELADO" />
                  ) : (
                    <ActionsBar
                      onPrint={() => {}}
                      onCancel={() => this.handleCancel(index, receipt.folio)}
                      href={
                        process.env.REACT_APP_URL_PUBLIC +
                        '/receipt/' +
                        Sales.id +
                        '/' +
                        index
                      }
                    />
                  )}
                  <br />
                  <Row>
                    <Col md={6}>
                      <div className="form-group">
                        <label style={{ fontWeight: 'bold' }} htmlFor="client">
                          FOLIO
                        </label>
                        <br />
                        <span>{receipt.folio}</span>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="form-group">
                        <label style={{ fontWeight: 'bold' }} htmlFor="client">
                          FECHA
                        </label>
                        <br />
                        <span>{moment(receipt.date).format('ll')}</span>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div className="form-group">
                        <label style={{ fontWeight: 'bold' }} htmlFor="client">
                          RECIBÍ DE:
                        </label>
                        <br />
                        <span>{receipt.from}</span>
                      </div>
                    </Col>
                  </Row>
                  {receipt.conceptsArray && receipt.conceptsArray.length > 0
                    ? receipt.conceptsArray.map((item, index) => {
                        return this.conceptComponent(item, index);
                      })
                    : this.conceptComponent(receipt)}
                  {receipt && receipt.providerPayment && (
                    <Row>
                      <Col md={6}>
                        <div className="form-group">
                          <label
                            style={{ fontWeight: 'bold' }}
                            htmlFor="client"
                          >
                            <i
                              class="fa fa-check"
                              aria-hidden="true"
                              style={{ fontSize: '12px', color: 'green' }}
                            ></i>
                            PAGO A PROVEEDOR
                          </label>
                        </div>
                      </Col>
                    </Row>
                  )}

                  <Row>
                    <Col md={6}>
                      <div className="form-group">
                        <label style={{ fontWeight: 'bold' }} htmlFor="client">
                          Archivos
                        </label>
                        <br />
                        {receipt.files.map((file, index) => (
                          <div
                            key={index}
                            style={{
                              fontSize: 12,
                              color: 'grey',
                            }}
                          >
                            <i className="fa fa-download" />{' '}
                            <a
                              href={
                                'https://s3.amazonaws.com/loopback-rsviajes/receipts/' +
                                file.name
                              }
                              target="_blank"
                            >
                              {file.name}
                            </a>
                          </div>
                        ))}
                      </div>
                    </Col>
                  </Row>
                </div>
              );
            })}
          </Col>
        </Row>

        {Sales.balance.totalPrice === Sales.balance.totalReceipt ||
        Sales.balance.totalDebit === 0 ? (
          <Button bsStyle="primary" fill disabled>
            Adeudo Saldado
          </Button>
        ) : (
          <Button
            bsStyle="primary"
            onClick={() =>
              this.props.dispatch({
                type: K.OPEN_MODAL_ADD,
                payload: 'receipt',
              })
            }
          >
            Agregar Recibo
          </Button>
        )}
      </div>
    );
  }
}

export default connect((state) => ({ Sales: state.Sales }))(receiptSale);



// WEBPACK FOOTER //
// ./src/views/Sales/cards/receiptSale.js